import axios from '../../library/modules/axios'
// 获取推荐列表
export function getRecommendList(params) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/recommend',
    method: 'get',
    params
  })
}

// 查询院区详情
export function getHospitalDetail(data) {
  return axios.service({
    url: `/apis/v1/tenant/customer/public/hospital-areas?hospital_area_id=${data && data.hospital_area_id ? data.hospital_area_id : ''}&hospital_area_code=${
      data.hospital_area_code ? data.hospital_area_code : ''
    }`,
    method: 'post'
  })
}
// 获取科室列表
export function getDepartmentList(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/departments/query',
    method: 'post',
    data
  })
}
// 获取字典数据
export function getTypeList(params) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/dict/labels',
    method: 'get',
    params
  })
}
// 推荐点击统计
export function recommendClick(data) {
  return axios.service({
    url: '/apis/v1/tenant/customer/public/statistics/recommend',
    method: 'put',
    data
  })
}

